import axios from 'axios'
import * as enVariables from 'src/config/config'
interface Params {
  topic?: string | null
  subTopic?: string
  type?: string
  /** Extra fields for POST /download-solutions (search + export). */
  [key: string]: string | number | boolean | string[] | null | undefined
}

export async function exportTopicsCsv(params: Params, token?: string) {
  const res = await axios.get(enVariables.API_HOST + '/api/reimport-els/download', {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return res
}

export async function exportSolutionsCsv(params: Params, token?: string) {
  const res = await axios.post(
    enVariables.API_HOST + '/api/reimport-els/download-solutions',
    { params },
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      responseType: 'blob',
    },
  )
  return res
}

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

/** Keep tag name; only remove chars unsafe for filesystems / download headers. */
export function sanitizeTagNameForExportFilename(tagName: string): string {
  return (tagName || '')
    .trim()
    .replace(/[\x00-\x1f\x7f]/g, '')
    .replace(/[\\/:*?"<>|]/g, '_')
    .replace(/[\s.]+$/g, '')
}

export function buildCustomTagExportBaseName(tagName: string): string {
  const baseName = sanitizeTagNameForExportFilename(tagName) || 'Custom Tag'
  return `${baseName}_Solution_Export`
}

function parseContentDispositionFilename(contentDisposition: string): string | undefined {
  const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;\n]+)/i)
  if (filenameStarMatch?.[1]) {
    try {
      return decodeURIComponent(filenameStarMatch[1].trim())
    } catch {
      // fall through to filename=
    }
  }
  const dispositionMatch = contentDisposition.match(/filename="([^"]+)"/i)
  if (dispositionMatch?.[1]) {
    return dispositionMatch[1].trim()
  }
  const unquotedMatch = contentDisposition.match(/filename=([^;\n]+)/i)
  return unquotedMatch?.[1]?.trim()
}

export function getSolutionsExportDownloadMeta(
  headers: Record<string, string | undefined> | undefined,
  baseName: string,
) {
  const contentType = headers?.['content-type'] || headers?.['Content-Type'] || ''
  const contentDisposition = headers?.['content-disposition'] || headers?.['Content-Disposition'] || ''
  const filenameFromHeader = contentDisposition ? parseContentDispositionFilename(contentDisposition) : undefined
  const isXlsx = contentType.includes('spreadsheetml')
  const extension = isXlsx ? 'xlsx' : 'csv'
  const baseFilename = filenameFromHeader || (baseName ? baseName.trim() : '')
  return {
    mimeType: isXlsx ? XLSX_MIME : 'text/csv',
    filename: baseFilename.includes('.') ? baseFilename : `${baseFilename}.${extension}`,
  }
}
